import { Placeholder } from 'react-bootstrap';

export function RunPlaceholder(props: { id?: string }) {
  const { id } = props;

  return (
    <Placeholder id={id} className='d-flex flex-column py-3 observed-element' animation='glow'>
      <Placeholder.Button xs={12} size='lg' className='btn btn-secondary p-5' outline='true' />
    </Placeholder>
  );
}
